import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

const formatCountdown = (remainingMilliseconds) => {
  const totalSeconds = Math.max(0, Math.floor(remainingMilliseconds / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map((value) => String(value).padStart(2, '0'))
    .join(':');
};

function PracticeExamExpirationNotice({
  nextWeeklyGenerationAt,
  weeklyPracticeExamBuildInProgress,
}) {
  const [now, setNow] = useState(Date.now());
  const [countdownExpired, setCountdownExpired] = useState(false);
  const generationTimestamp = Number(nextWeeklyGenerationAt);
  const remainingMilliseconds = Math.max(0, generationTimestamp - now);
  const countdownAtZero = countdownExpired || weeklyPracticeExamBuildInProgress;
  const showCountdown =
    countdownAtZero || remainingMilliseconds <= DAY_IN_MILLISECONDS;

  useEffect(() => {
    if (countdownAtZero) return undefined;

    const timer = window.setInterval(() => setNow(Date.now()), 1000);

    return () => window.clearInterval(timer);
  }, [countdownAtZero]);

  useEffect(() => {
    if (remainingMilliseconds === 0) setCountdownExpired(true);
  }, [remainingMilliseconds]);

  useEffect(() => {
    if (
      countdownExpired &&
      !weeklyPracticeExamBuildInProgress &&
      generationTimestamp > Date.now()
    ) {
      setCountdownExpired(false);
      setNow(Date.now());
    }
  }, [
    countdownExpired,
    generationTimestamp,
    weeklyPracticeExamBuildInProgress,
  ]);

  if (!Number.isFinite(generationTimestamp)) return null;

  return (
    <span
      className={`practice-exam-expiration${
        showCountdown ? ' practice-exam-expiration--urgent' : ''
      }`}
    >
      {showCountdown
        ? `Expires in ${formatCountdown(
            countdownAtZero ? 0 : remainingMilliseconds,
          )}`
        : `Expires on ${new Date(generationTimestamp).toLocaleDateString(
            'en-US',
            {
              month: 'short',
              day: 'numeric',
              timeZone: 'America/Los_Angeles',
            },
          )}`}
    </span>
  );
}

PracticeExamExpirationNotice.propTypes = {
  nextWeeklyGenerationAt: PropTypes.number.isRequired,
  weeklyPracticeExamBuildInProgress: PropTypes.bool.isRequired,
};

export default PracticeExamExpirationNotice;
